<div class="wrapper">
  <!-- Sidebar -->
  <app-sidebar [active]="active"></app-sidebar>

  <!-- Page Content -->
  <div id="content">
    <div> <button class="button-toggle" (click)="showSidebar()">Ver historial de versiones</button> </div>
    <p class="text-center"> Términos y condiciones para clientes Triidy.</p>
    <p class="text-center"> LEE CUIDADOSAMENTE LOS SIGUIENTES TÉRMINOS DE SERVICIO PARA LOS CLIENTES.</p>

    <p class="text-center"> <b>Versión vigente 03/07/2020 </b></p>


    <p>
      Este contrato describe los términos y condiciones generales (los "Términos y Condiciones Generales") aplicables al
      uso de los servicios ofrecidos por <b>Triidy Soft sas identificado con nit 901277226-5</b> ("los Servicios")
      dentro
      del sitio www.triidy.com.
      Cualquier persona que desee acceder y/o usar el sitio o los servicios podrá hacerlo sujetándose a los Términos y
      Condiciones Generales, junto con todas las demás políticas y principios que rigen <b>Triidy Soft
      </b> y que son incorporados al presente por referencia.
    </p>


    <p> <b>CUALQUIER PERSONA QUE NO ACEPTE ESTOS TÉRMINOS Y CONDICIONES GENERALES, LOS CUALES TIENEN UN CARÁCTER
        OBLIGATORIO Y
        VINCULANTE, DEBERÁ ABSTENERSE DE UTILIZAR EL SITIO Y/O LOS SERVICIOS.</b></p>


    <p>
      El Usuario debe leer, entender y aceptar todas las condiciones establecidas en los Términos y Condiciones
      Generales
      y en las Políticas de Privacidad, así como en los demás documentos incorporados a los mismos por referencia,
      previo
      a su inscripción como
      Usuario de <b> Triidy Soft</b>.
    </p>

    <div class="triidy-plataforma">
      <p>
        Triidy es la plataforma que conecta el comercio electrónico y permite que esté al alcance de cualquier persona
        ya
        que integra los entes más importantes en este sector, como proveedores, logística, franquicias, lideres entre
        otros.
      </p>

      <p>
        Por medio del modelo Dropshipping Triidy a logrado conectar los proveedores con los comercios electrónicos,
        permitiendo que este sea un modelo de negocio social.
      </p>

      <p>
        Dropshipping es un modelo en el cual un proveedor de productos los carga a nuestra plataforma con su respectivo
        inventario y descripción, los comercios electrónicos agregan estos productos a su lista de ventas para
        empezarlos
        a promover en sus paginas
        web y redes sociales, así cuando se haga efectiva una venta de uno de estos, simplemente lo factura en la
        plataforma inmediatamente al proveedor le va llegar la solicitud de estos productos para alistar y despachar.
      </p>

      <p>
        Cuando un comercio electrónico factura la venta, inmediatamente se le descuenta el valor del costo desde su
        monedero virtual pero no te pagamos a ti este dinero hasta que el producto se encuentre entregado al cliente
        final, de esta forma garantizamos
        que haya llegado el producto correcto.
      </p>

      <p>
        En el presente documento se adjuntan todos los requisitos que se deben tener para ser comercio, proveedor,
        franquiciado, líder y mensajero en Triidy y hacer parte de nuestra comunidad, logrando potenciar el comercio
        digital a nivel de Latinoamérica.
      </p>

    </div>


    <p class="text-center"> <b>OFERTA DE SERVICIOS TRIIDY </b></p>

    <p class="text-center"> <b>1 REPARTO CON RECAUDO (M.E – M.V.T – M.V.A) - A Través de ENVIA </b> </p>

    <p> Adicional a la entrega normal dentro del proceso logístico operativo, podrá incluirse el recaudo del valor del
      Producto el cual aplica para los servicios de ME: MENSAJERÍA EXPRESA, MVT: MERCANCÍA VÍA</p>

    <p>TERRESTRE y MVA: MERCANCÍA VÍA AÉREA, con un cubrimiento a nivel Urbano, Regional, y Nacional. </p>

    <p>De acuerdo a matriz suministrada) </p>

    <p>El servicio de REPARTO CON RECAUDO se prestará a través de la transportadora ENVIA COLVANES </p>

    <p>Quien realizará el cobro contra entrega al cliente y consignará el dinero en la cuenta bancaria de Triidy Soft
      SAS
    </p>

    <p>Posteriormente Triidy Soft consignará el dinero a la cuenta bancaria o monedero virtual que determine el cliente
      previo el cliente solicite el pago a través de la plataforma en la opción Menú/Cargas masivas/pagos/obtener envíos
      disponibles para pago/solicitar
      Dinero.
    </p>

    <p class="text-center">4.1. PARAMETROS DE NEGOCIACION</p>

    <p>
      La propuesta de servicios ofrecida se enmarca dentro de nuestros esquemas de operación en tiempos, cubrimiento y
      horarios propios de nuestro portafolio, cualquier ajuste o servicio que implique diferencias significativas en
      cualquiera de las actividades
      será ajustada y perfeccionada una vez aceptada nuestra propuesta comercial
    </p>

    <p class="text-center">
      4.2. ANEXOS:
    </p>


    <p>
      - Matriz de cubrimientos para reparto con recaudo (es diferente a la matriz genérica de destinos)
    </p>

    <p>
      - Imagen del Sticker que deben llevar todas las unidades que se manejen bajo este servicio (sin
    </p>

    <p>
      Excepción), Nosotros Según Disponibilidad de la transportadora Suministramos Stickers y o material de empaque solo
      en los casos que la transportadora suministre, de lo contrario el cliente puede imprimir stickers Verdes de 5 cm
      de
      ancho por 10 cm de largo
      con la palabra
    </p>

    <p>
      PARA COBRO
    </p>

    <p class="text-center">
      4.3. CONDICIONES GENERALES:
    </p>

    <p>
      a) Número de unidades: Cada guía puede amparar tan solo un pedido, a su vez compuesto por varias unidades o
      productos. b) El precio pactado que se genere con ocasión a la aceptación de la presente oferta incluye la
      remuneración de todas y cada una de
      las actividades que hacen parte del servicio de transporte de carga.
    </p>

    <p>
      c) Valor a recaudar: Es el dinero que deberá Recaudar el Operador de Servicio al momento de la entrega, el cual
      podrá tener un monto máximo por guía de 2 SMMLV ($1.475.000 m/cte.).
    </p>
    <p>
      d) Los montos recaudados serán depositados en la cuenta asignada por el cliente en un tiempo de máximo 24 horas
      después de la solicitud del cliente de dinero.
    </p>
    <p>
      e) Para la facturación de este concepto, el valor será incluido en el valor total del flete por cada envió y no se
      otorgará ningún tipo de descuento sobre el rubro de recaudo.
    </p>
    <p>
      f) Entrega de la mercancía: solo se entregará el o los productos una vez se ha recibido el dinero.
    </p>
    <p>
      g) Guía On Line: La guía para el proceso reparto con recaudo siempre es On-Line crédito a través de nuestra
      plataforma opción PAGO CONTRAENTREGA al momento de facturar
    </p>
    <p>
      h) Diligenciamiento de la guía: Valor Recaudo, se relaciona el valor del producto, que corresponde al dinero a
      recaudar, este es el valor final a cobrar al cliente incluido el envío.
    </p>
    <p>
      i) Rotulo: El envío debe estar identificado con el sticker y su leyenda “PARA COBRO”.
    </p>
    <p>
      j) Los tiempos de entrega para este proceso son los mismos que actualmente aplican para los servicios Mensajería
      por
      parte de la transportadora. TRIIDY SOFT se encargara de comunicar al cliente y suministrar la información acerca
      de
      los destinos Habilitados
      para Reparto con recaudo y los días de entrega por parte de la Transportadora.
    </p>

    <p>
      TRIIDY SOFT facturará Inmediatamente al cliente el valor de todos los costos logísticos incurridos en ese período,
      y
      se Cruzará con el Dinero recaudado, así como los Costos por Devoluciones que hayan sido generados durante el
      periodo.
    </p>

    <p>
      El primer retiro de dinero en el día de la plataforma hacia la cuenta bancaria del usuario no genera ningún costo
      y
      puede tardar un tiempo máximo de 24 horas en días hábiles, el segundo retiro de dinero en el mismo día si tiene un
      cobro el cual depende
      del banco al cual se realiza la solicitud. Si el usuario realiza la solicitud mediante el botón “ADELANTAR” este
      tendrá un costo informado al momento de hacerla, este valor se facturará como manejo plataforma debido a que
      Triidy
      está adelantando
      un dinero que todavía la Transportadora no ha cancelado.
    </p>

    <p class="text-center">
      5. TARIFAS
    </p>

    <p>
      <img class="image" id="Image1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Tarifas2021.png">
    </p>

    <p>
      El precio de las tarifas no tiene un valor fijo ya que depende de distintos factores tales como:

    </p>

    <ul>
      <li>El municipio de despacho</li>
      <li>El municipio de entrega</li>
      <li>El valor a recaudar ( en caso de ser reparto con recaudo)</li>
      <li>El valor asegurado</li>
      <li>El tamaño del paquete</li>
    </ul>

    <p>
      Estos son los precios bases para paquetes con envío contra entrega de hasta 4kg de recaudo menor a 100.000 y
      entregas en municipios principales. despachando desde la ciudad de Medellín o Bogotá
    </p>

    <p>
      Para efectos de revisiones y comentarios dirigirse vía correo electrónico al correo
    </p>

    <p>
      Triidysoft@Gmail.com
    </p>

    <p class="text-center">
      6. OBSERVACIONES
    </p>

    <p>
      6.1. En caso de aprobarse esta oferta, favor adjuntar los siguientes documentos:
    </p>

    <p>
      a) Cámara de Comercio.
    </p>

    <p>
      b) Copia de cédula de representante legal.
    </p>

    <p>
      c) RUT.
    </p>

    <p>
      d) Formulario de Vinculación
    </p>

    <p>
      e) Aceptación de la oferta
    </p>

    <p>
      enviar estos documentos al correo Triidysoft@gmail.com
    </p>


    <p>
      6.2. Debes Tener presente que las siguientes mercancías no pueden ser transportadas bajo ninguna circunstancia:
    </p>

    <p>
      a) Material explosivo e inflamable
    </p>

    <p>
      b) Material Radioactivo
    </p>

    <p>
      c) Gases comprimidos
    </p>

    <p>
      d) 4. Material que deba mantenerse sobre condiciones de refrigeración, congelación o calefacción </p>

    <p>
      e) Perecederos y/o comestibles con un tiempo inferior a tres meses
    </p>

    <p>
      f) Obras de arte
    </p>

    <p>
      g) Títulos valores, monedas y/o papel moneda, metales y piedras preciosas
    </p>

    <p>
      h) Activos fijos deteriorados
    </p>

    <p>
      i) Narcóticos y/o sustancias psicoactivas
    </p>

    <p>
      j) Armas y municiones
    </p>

    <p>
      k) Especies animales y vegetales
    </p>

    <p>
      l) Artículos al margen de la ley

    <p>
      7. AUTORIZACIÓN DE TRATAMIENTO DE DATOS PERSONALES
    </p>

    <p>
      Declaro que he sido informado: (i) Que TRIIDY SOFT S.A.S. en lo sucesivo actuará</p>

    <p>
      Directamente o a través de terceros como el responsable del Tratamiento de mis datos personales y ha puesto a mi
      disposición la línea de atención nacional (+57) (4)5065844, el correo electrónico
    </p>

    <p>
      Triidysoft@Gmail.com y las oficinas de atención al cliente a nivel nacional con sede principal en Medellín Carrera
      77b # 48c 64, cuya información puedo consultar en www.Triidy.com, disponibles de lunes a viernes de 9:30 a.m. a
      4:30
      Pm. y sábados de 9:30a.m
      a 12:00p.m., para la atención de requerimientos relacionados con el tratamiento de mis datos personales y el
      ejercicio de los derechos mencionados en esta autorización; (ii) Mis datos serán tratados para fines
      precontractuales, contractuales,
      pos contractuales, comerciales, de atención al cliente y mercadeo, procesamiento, investigación, capacitación,
      acreditación, consolidación, organización, actualización, reporte, estadística, encuestas, atención y tramitación;
      (iii) Mis derechos
      como titular del dato son los previstos en la Constitución y la ley, especialmente el derecho a conocer,
      actualizar,
      rectificar y suprimir mi información personal, así como el derecho a revocar el consentimiento otorgado para el
      tratamiento
      de datos personales. Estos derechos los puedo ejercer a través de los canales dispuestos por TRIIDY SOFT SAS para
      la
      atención al público y observando la Política de Tratamiento de datos personales de TRIIDY SOFT SAS disponible en
      http://www.triidy.com
      (iv) Es voluntario responder preguntas que eventualmente me sean hechas sobre datos sensibles o datos de menores
      de
      edad, y que éstos últimos serán tratados respetando sus derechos fundamentales e intereses superiores.</p>

    <p>
      Son datos sensibles, aquellos que afectan la intimidad del Titular o cuyo uso indebido puede generar
      discriminación,
      por ejemplo, la orientación política, las convicciones religiosas o filosóficas, de derechos humanos, así como los
      datos relativos a la
      salud, a la vida sexual y los datos biométricos.
    </p>

    <p>
      Teniendo en cuenta lo anterior, autorizo de manera voluntaria, previa, explícita, informada e inequívoca a TRIIDY
      SOFT y a quien le sean cedidos los derechos, para tratar mis datos personales, con finalidad principal de
      contratación, ejecución y comercialización
      de los bienes y servicios del responsable del Tratamiento, así como el contacto a través de medios telefónicos,
      electrónicos (SMS, chat, correo electrónico y demás medios considerados electrónicos) físicos y/o personales.
    </p>


    <p>
      TRIIDY SOFT podrá usar mi información para los siguientes fines:
    </p>


    <p>
      a. Efectuar las gestiones pertinentes para el desarrollo de la etapa precontractual, contractual y pos contractual
      con TRIIDY SOFT SAS y terceros que contraten con él, respecto de cualquiera de los productos y servicios ofrecidos
      por ella que haya o no
      adquirido o, respecto de cualquier relación de negocios o comercial que tenga TRIIDY SOFT, así como dar
      cumplimiento
      a la ley colombiana o extranjera y las órdenes de autoridades judiciales o administrativas.
    </p>

    <p>
      b. Realizar invitaciones a eventos, mejorar productos y servicios u ofertar nuevos productos y todas aquellas
      actividades asociadas a la relación comercial o vínculo existente con TRIIDY SOFT o terceros que contraten con él,
      o
      aquel que llegare a tener.
    </p>

    <p>
      c. Gestionar trámites (solicitudes, quejas, reclamos), realizar análisis de riesgo, efectuar encuestas de
      satisfacción respecto de los bienes y servicios de TRIIDY SOFT, así como de los aliados comerciales de TRIIDY SOFT
      SAS
    </p>

    <p>
      d. Suministrar información de contacto y documentos pertinentes a la fuerza comercial y/o red de distribución,
      tele
      mercadeo, investigación de mercados y cualquier tercero con el cual TRIIDY SOFT posea un vínculo contractual de
      cualquier índole.
    </p>

    <p>
      e. Dar a conocer, transferir y/o trasmitir mis datos personales dentro y fuera del país, a cualquier empresa o a
      terceros como consecuencia de un contrato, ley o vínculo lícito que así lo requiera, o para implementar servicios
      de
      computación en la nube.
      Para todo lo anterior, otorgo mi autorización expresa e inequívoca.
    </p>

    <p>
      f. Suministrar a las asociaciones gremiales del sector de las telecomunicaciones y a los sistemas manejados por
      éstas, los datos personales necesarios p ara la realización de estudios y en general la administración de sistemas
      de información del sector
      correspondiente.
    </p>

    <p>
      g. Conocer mis datos que reposen en operadores de bancos de datos de información financiera de que trata la Ley
      1266
      de 2008 o las normas que la modifiquen, adicionen o sustituyan y proporcionarles mi información a los mismos.
    </p>

    <p>
      h. Acceder y consultar mis datos personales que reposen o estén contenidos en bases de datos o archivos de
      cualquier
      Entidad Privada o Pública (entre otros, los Ministerios, los
    </p>

    <p>
      Departamentos Administrativos, la DIAN, la Fiscalía, Registraduría Nacional del Estado
    </p>

    <p>
      Civil, Juzgados, tribunales y altas Cortes) ya sea nacional, internacional o extranjera.
    </p>

    <p>
      i. Transferir o transmitir los datos a las compañías matrices, filiales, subsidiarias, controladas de TRIIDY SOFT,
      dentro y fuera del país.
    </p>

    <p>
      j. Crear bases de datos para los fines descritos en la presente autorización. Otorgo mi consentimiento a TRIIDY
      SOFT
      para tratar mi información personal de acuerdo con la
    </p>

    <p>
      Política de Tratamiento de Datos Personales y por tanto, me comprometo a conocer el aviso de privacidad y la
      política mencionada disponible en: http://www.triidy.com Autorizo a
    </p>

    <p>
      TRIIDY SOFT SAS a modificar o actualizar su contenido a fin de atender reformas legislativas, políticas internas o
      nuevos requerimientos para la prestación u ofrecimiento de servicios o productos, dando aviso previo por medio de
      la
      página web de la compañía
      o por correo electrónico. La información del formato del cual forma p arte la presente autorización la he
      suministrado de forma voluntaria y es verídica.
    </p>


    <p><b>Lo que debemos cumplir para ser proveedor Dropshipping o franquiciado en Triidy</b></p>

    <ul>
      <li>
        El proveedor se encuentra en la responsabilidad de garantizar que los valores de los inventarios que se
        encuentran
        registrados en la plataforma si correspondan con las cantidades reales que tiene físicamente, ya que esto
        certifica su responsabilidad y
        compromiso con el comercio y sus ventas, garantizando el despacho en los tiempos establecidos. El no cumplir con
        estos valores generará un llamado de atención, una baja en el puntaje de calificación y un cobro del 30% sobre
        el
        valor de
        la venta el cual se retirará de su billetera hacia la billetera del comercio electrónico.
        <br> En casos fortuitos como vacaciones, por favor informar a la plataforma por medio de ticket he INACTIVAR los
        productos para que los comercios no los sigan facturando.
      </li>
      <li>
        Cargar el nombre correcto del producto, su descripción con características específicas, el precio de venta, el
        precio sugerido de venta y el tiempo de garantía. (el precio de venta no puede ser superior a lo que se tiene
        establecido en las páginas oficiales
        COMO PROVEEDOR) (ver documento de garantías y embalaje).
      </li>
      <li>
        Utilizar el material de empaque adecuado como cinta, papel chicle, papel burbuja, cajas, bolsas con cierre de
        seguridad o bolsas completamente selladas ya que así logramos evitar pérdidas o averías sobre todo en productos
        líquidos, los cuales en caso
        de daño durante su transporte deben ser asumidos por la bodega.
      </li>
      <li>
        Usar sello contramarcado con los datos de la bodega para identificar de manera idónea la firma de documentos
        como
        las devoluciones o comprobantes ante las transportadoras.
      </li>
      <li>
        Realizar y garantizar los despachos de los productos en un tiempo menor a 48 horas ya que esto permite que las
        entregas al cliente final sean mucho más rápidas y efectivas. El no cumplir con estos tiempos por razones
        directamente imputables al proveedor
        (malos procesos de impresión, mal manejo de la plataforma, malos procesos de packing, mal control del
        inventario,
        mal manejo del tiempo de despacho, mal procedimiento de entrega de los paquetes a las transportadoras) generará
        un
        llamado
        de atención, una baja en el puntaje de calificación y un cobro del 30% del valor completo de la venta el cual se
        retirará de su billetera hacia la billetera del comercio electrónico.
      </li>
      <li>
        Siempre debes escanear los códigos de barras de las guías con la pistola para así despachar los envíos y generar
        la relación la cual es el documento que nos firma el funcionario de envía como garantía de que le entregamos los
        productos y en caso tal de
        pérdidas o daños es el respaldo para generar reclamaciones ante la transportadora, este documento debe ser
        legible.
      </li>
      <li>
        Procesar los estados en tiempo real (DESPACHADO, DEVOLUCIÓN Y ANULACIÓN)
        <br> Si te llega una devolución es muy necesario que la escanees en el módulo de devoluciones en Triidy, no
        hacerlo genera error en los inventarios de la bodega al mostrar la unidad en estado de pérdida.
      </li>
      <li>
        Debemos responder las solicitudes de disputas establecidas por los comercios por medio de la plataforma, en caso
        tal de transcurrir 5 días y no tener una respuesta por dicho medio, la plataforma generará reajuste por el valor
        del producto a favor del
        comercio.
      </li>
      <!-- <li>
                  Tener inventarios en tiempo real (actualizado y sin errores para el despacho diario) ya que esto permite que las tiendas estén completamente seguras de que pueden venderlos.
                  <br> En casos fortuitos como vacaciones, por favor informar a la plataforma por medio de ticket he INACTIVAR los productos para que los comercios no los sigan facturando.
              </li>
              <li>
                  Cargar el nombre correcto del producto, su descripción con características específicas, el precio de venta, el precio sugerido de venta y el tiempo de garantía. (el precio de venta no puede ser superior a lo que se tiene establecido en las páginas oficiales
                  COMO PROVEEDOR) (ver documento de garantías y embalaje).
              </li>
              <li>
                  Utilizar el material de empaque adecuado como cinta, papel chicle, papel burbuja, cajas, bolsas con cierre de seguridad o bolsas completamente selladas ya que así logramos evitar pérdidas o averías sobre todo en productos líquidos, los cuales en caso
                  de daño durante su transporte deben ser asumidas por la bodega.
              </li>
              <li>
                  Usar sello contramarcado con los datos de la bodega para identificar de manera idónea la firma de documentos como las devoluciones o comprobantes ante las transportadoras.
              </li>
              <li>
                  Despachar los productos con la transportadora con un tiempo no máximo a 24 horas ya que esto permite que las entregas a los clientes sean mucho más ágiles y puedas obtener tus ganancias más rápido.
              </li>
              <li>
                  Siempre debes escanear los códigos de barras de las guías con la pistola para así despachar los envíos y generar la relación la cual es el documento que nos firma el funcionario de envía como garantía de que le entregamos los productos y si llegan a ver
                  pérdidas o daños es el respaldo para generar reclamaciones ante la transportadora.
              </li>
              <li>
                  Procesar los estados en tiempo real (DESPACHADO, DEVOLUCIÓN Y ANULACIÓN)
                  <br> Si te llega una devolución es muy necesario que la escanees en el módulo de devoluciones en Triidy, no hacerlo genera error en los inventarios de la bodega al mostrar la unidad en estado de pérdida.
              </li>
              <li>
                  Debemos responder las solicitudes de disputas por los clientes por medio de la plataforma, ya que si no lo hacemos esto genera posibles suspensiones.
              </li> -->
    </ul>

    <p><b>1. Lo que genera penalización en Triidy siendo proveedor y causales de retiros</b></p>

    <ul>
      <li>
        Desactivar o descargar los productos cuando hay comercios activos vendiéndolos, sin previo aviso o justa causa.
      </li>
      <li>
        Demoras reiterativas superiores a 48 horas en los despachos de los pedidos de los comercios, en caso tal de
        generarse 3 alertas negativas por tiempo de despacho se procede a inhabilitar de la plataforma.
      </li>
      <li>
        No tener relaciones cargadas en la plataforma para solicitar reclamos ante envía de un producto. Ya que con esto
        podemos recuperar el producto solicitar indemnización con la transportadora de lo contrario la reclamación no
        procede y se realiza reajuste
        del monedero del proveedor al comercio por el valor del producto.
        <ul>
          <li>Tener reclamaciones reiterativas por producto mal empacado o en mal estado</li>
          <li>Despacho con contenido incorrecto</li>
          <li>Faltantes</li>
        </ul>
      </li>
      <li>
        Si cargas un inventario o registras un producto, debes garantizar que tengas el stock disponible para despacho.
      </li>
      <li>
        Utilizar, lucrarse, emplear o explotar la información de venta de los comercios para realizar ventas propias de
        los productos y desactivarlos (esto genera desactivación de la cuenta inmediata y posibles demandas colectivas
        por
        robo, expoliación o sustracción
        de información sensible perteneciente al comercio o Triidy).
      </li>
      <li>
        Proponer, plantear, ofrecer, sugerir o recomendar a los comercios electrónicos que se encuentran en Triidy
        realizar uso o transacciones por medio de otras plataformas las cuales no tienen ningún tipo de relación con
        nosotros. (esto genera desactivación
        de la cuenta inmediata y posibles demandas colectivas por robo, expoliación o sustracción de información
        sensible
        perteneciente al comercio o Triidy).
      </li>
      <li>
        No está permitida ninguna acción o uso de dispositivo, software, u otro medio tendiente a interferir tanto en
        las
        actividades y operatoria de como en las ofertas, descripciones, cuentas o bases de datos de Triidy Soft.
      </li>
      <li>
        Cualquier intromisión, tentativa o actividad violatoria o contraria a las leyes sobre derecho de propiedad
        intelectual y/o a las prohibiciones estipuladas en este contrato harán pasible a su responsable de las acciones
        legales pertinentes, y a las sanciones
        previstas por este acuerdo, así como lo hará responsable de indemnizar los daños ocasionados.
      </li>
    </ul>

    <p><b>2. Lo que puede hacer Triidy parcialmente tanto para el proveedor como para el comercio electrónico</b></p>

    <ul>
      <li>
        Entregar reportes de despachos, pagos y solicitudes en tiempo real.
      </li>
      <li>
        Hacer valer los costos de las garantías impuestas por el proveedor cuando crea los productos y están dentro del
        tiempo estipulado para solicitar.
      </li>
      <li>
        Hacer valer los costos de fletes por error de despacho como productos con solicitudes de anulación, productos
        erróneos, en mal estado entre otros.
      </li>
      <li>
        Generar devolución de guías si:
        <ul>
          <li>Se colocan en estado despachado, pero no se entregó a la transportadora.</li>
          <li>El pedido tiene más de 3 días sin gestión en la plataforma.</li>
        </ul>
      </li>
      <li>
        Generar reajustes a monederos dependiendo de los casos que se presenten, sean imputables a la transportadora, al
        proveedor o el comercio electrónico, brindando claridad en cada proceso que se realice.
      </li>
    </ul>

    <p>
      <b>Sanciones. Suspensión de operaciones</b>
      <br> Triidy podrá advertir, suspender en forma temporal o inhabilitar definitivamente la cuenta de un proveedor,
      aplicar una sanción que impacte negativamente en la reputación de este, iniciar las acciones que se estimen
      pertinentes y/o suspender
      la prestación de sus servicios si:
    </p>
    <ul>
      <li>
        Si se quebranta alguna ley, o cualquiera de las estipulaciones de los Términos y Condiciones y demás políticas
        de
        Triidy Soft
      </li>
      <li>
        Si incumpliera sus compromisos como Usuario
      </li>
      <li>
        Si se incurriera a criterio de Triidy en conductas o actos dolosos o fraudulentos que afecten a los comercios.
      </li>
      <li>
        Si no pudiera verificarse la identidad del Usuario o cualquier información proporcionada por el mismo fuese
        errónea.
      </li>
    </ul>
    <p>
      <b>Obligaciones del Proveedor</b>
      <br> El Usuario Proveedor debe tener capacidad legal para vender el bien objeto de su oferta. Asimismo, debe
      cumplir
      con todas las obligaciones regulatorias pertinentes y contar con los registros, habilitaciones, permisos y/o
      autorizaciones
      exigidos por la normativa aplicable para la venta de los bienes y servicios ofrecidos. Si el Usuario Proveedor ha
      recibido una oferta sobre el precio que estableció en la publicación, queda obligado a intentar comunicarse con el
      usuario tienda
      virtual y completar la operación que ofertó. La cancelación de una venta por parte del Usuario proveedor impactará
      en su reputación. Aquel Usuario proveedor que tenga un porcentaje de ventas canceladas podrá ser advertido,
      suspendido y/o inhabilitado
      por Triidy para continuar operando en el sitio.
      <br> Dado que Triidy es un punto de encuentro entre proveedor y la tienda virtual y no participa de las
      operaciones
      que se realizan entre ellos, el usuario proveedor será responsable por todas las obligaciones y cargas impositivas
      que correspondan
      por la venta de sus artículos, sin que pudiera imputarse a Triidy algún tipo de responsabilidad por
      incumplimientos
      en tal sentido.
    </p>

    <p>
      <b>Impuestos</b>
      <br> Como se menciona anteriormente, Triidy sólo pone a disposición de los Usuarios un espacio virtual que les
      permite comunicarse mediante Internet para encontrar una forma de vender o comprar artículos y/o servicios. Triidy
      no tiene participación
      alguna en el proceso de negociación y perfeccionamiento del contrato definitivo entre las partes. Por eso, Triidy
      no
      es responsable por el efectivo cumplimiento de las obligaciones fiscales o impositivas establecidas por la ley
      vigente.
      <br> El usuario proveedor acepta que el usuario tienda virtual puede revocar la compra dentro de un plazo de 3
      días
      desde que llegue el producto al cliente final. Asimismo, el usuario proveedor acepta que las tiendas podrán pedir
      el
      cambio
      o devolución del producto.
      <br> En cualquiera de los mencionados casos, el usuario proveedor deberá aceptar el cambio o devolución del
      producto
      vendido dependiendo del caso deberá hacerse cargo de los gastos que esto conlleve, incluyendo los costos de envío
      que fueren
      necesarios. Triidy podrá debitar estos costos de la cuenta de la billetera virtual del usuario proveedor.
    </p>

    <p><b>Mensajeros</b></p>

    <p>
      El usuario reconoce y acepta que estos Términos y Condiciones del botón (Triidy /Entregas) son aplicables a los
      casos en que, para la prestación del servicio, las características del mismo, sus condiciones técnicas, económicas
      y
      jurídicas han sido negociadas
      y pactadas de mutuo acuerdo entre las partes del contrato (Consumidor y Mandatario) y, por lo tanto, son el
      resultado del acuerdo particular y directo entre las mismas.
    </p>

    <ol>
      <li>
        El Usuario no podrá realizar envíos que contengan una mercancía que supere un valor comercial de más de
        cuatrocientos setenta y cuatro mil pesos colombianos ($ 470.000). El usuario reconoce y acepta que, en caso de
        enviar algún paquete que contenga mercancía
        por un valor superior al anterior, lo hará bajo su propio riesgo y libera a Triidy soft y al Mandatario
        (Mensajero
        Triidy) de cualquier tipo de responsabilidad al respecto.
      </li>
      <li>
        En caso de pérdida, merma o daño del envío imputable a Triidy soft, solo se hará devolución del monto declarado
        del envío, con un tope de noventa mil pesos (90.000).
      </li>
      <li>
        Para todos los efectos, Triidy funge como una simple plataforma virtual mediante la cual, el usuario
        (Consumidor),
        podrá solicitar a un Mensajero Triidy (Mandatario), el servicio de favor, el cual se llevará a cabo por el mutuo
        acuerdo entre las partes.
        Triidy Soft aclara que la relación será directamente entre el Consumidor y el Mandatario y se mantendrá al
        margen
        de la misma, no siendo responsable ni siquiera solidariamente por cualquier hecho que pueda generarse de la
        relación entre
        las dos partes descritas anteriormente.
      </li>
      <li>
        El usuario reconoce y acepta que no enviará ningún tipo de mercancía o productos que sean considerados como
        ilícitos bajo la normatividad colombiana, así como tampoco solicitará o enviará divisas, joyas o cualquier otro
        tipo de objeto de valor. De esta
        manera, el usuario acepta que es el único y entero responsable frente a las autoridades sobre la mercancía que
        envía, liberando a Triidy Soft y al Mandatario de cualquier tipo de responsabilidad. El usuario tiene la
        obligación de declarar
        la mercancía que está enviando antes de solicitar la orden. Así, bajo la gravedad del juramento, el usuario
        acepta
        que la mercancía que está enviando es la descrita en la plataforma Triidy soft.
      </li>
      <li>
        El mensajero se debe comunicar con el destinatario al número de celular para coordinar la receptoría de la
        unidad
        antes de dirigirse al punto. En caso tal de presentarse alguna novedad con el pedido, el mensajero ingresa la
        información sobre esta en la
        plataforma para que el comercio gestione la novedad de manera inmediata.
      </li>
      <li>
        El comercio tiene un tiempo de 24 horas para la gestión de dichas novedades, en caso tal de no brindarse una
        gestión, se genera devolución de la unidad en la plataforma teniendo en cuenta las siguientes variables: · En
        caso
        tal que el mensajero se dirija
        hasta el punto por confirmación del cliente, pero no sea posible la entrega la unidad por disponibilidad de
        este,
        el mensajero debe tomar material probatorio como el registro de la llamada con el cliente y una imagen o video
        del
        punto
        explicando lo sucedido, para así generar pago sobre el flete en devolución. · En caso tal de presentarse una
        cancelación del pedido sin el mensajero haberse dirigido al punto, generamos devolución sin cobro del flete al
        comercio.
      </li>
      <li>
        Si se genera entrega del pedido se debe establecer dicha información en la plataforma, una vez se hace el
        proceso,
        el mensajero obtiene el pago del flete.
      </li>
      <li>
        Un pedido no puede contar con más de 24 horas sin información después de ser tomado por el mensajero, es decir,
        debe tener novedad o estado de entrega.
      </li>
      <li>
        Ninguna devolución se puede llevar a cabo sin tener antes un estado de novedad ingresado mínimo 24 horas antes,
        esto muestra a los comercios que se realizó una gestión de manera efectiva (tener en cuenta el punto 3).
      </li>
      <li>
        El comercio puede reprogramar la venta para máximo las próximas 48 horas después de establecida la novedad, en
        caso tal de solicitar más tiempo para la entrega, el mensajero puede generar devolución de la unidad, para que
        se
        facture la venta en el tiempo
        correcto.
      </li>
    </ol>

    <p><b>4. Lideres</b></p>

    <p>
      Son personas naturales o jurídicas que realizan captación de clientes para Triidy y así tener un beneficio mutuo
      por
      los registros que estos realizan de tal forma que apoyan el trabajo comercial, pero son personas o empresas
      totalmente externas a Triidy.
    </p>

    <p>
      El líder no puede presentarse como empleado, socio, directivo administrador de Triidy soft ya que representa
      simplemente una relación comercial que los beneficia mutuamente por la captación de clientes.
    </p>

    <p>
      Triidy soft puede darle manejo a los clientes que traen los lideres y administrarlos como sus clientes brindándole
      toda la información sobre el servicio, descuentos ofertas o temas de fidelización y generación de marca, con la
      finalidad de brindar un
      mejor servicio.

    </p>

    <p><b>5. Responsabilidad</b></p>


    <p>
      Los Servicios sólo están disponibles para personas que tengan capacidad legal para contratar. No podrán utilizar
      los
      servicios las personas que no tengan esa capacidad, los menores de edad o Usuarios de Triidy Soft que hayan sido
      suspendidos temporalmente
      o inhabilitados definitivamente. Si estás inscribiendo un Usuario como Empresa, debes
    </p>
    tener capacidad para contratar a nombre de tal entidad y de obligar a la misma en los términos de este Acuerdo.

    <p><b>Triidy Soft</b> sólo pone a disposición de los Usuarios un espacio virtual que les permite ponerse en
      comunicación mediante Internet para encontrar una forma de vender o comprar servicios o bienes.</p>

    <p><b>Triidy Soft</b> no es el propietario de los artículos ofrecidos, no tiene posesión de ellos ni los ofrece en
      venta.
    </p>

    <p><b>Triidy Soft</b> no interviene en el perfeccionamiento de las operaciones realizadas entre los Usuarios ni en
      las
      condiciones por ellos estipuladas para las mismas, por ello no será responsable respecto de la existencia,
      calidad,
      cantidad, estado,
      integridad o legitimidad de los bienes ofrecidos, adquiridos o enajenados por los Usuarios, así como de la
      capacidad
      para contratar de los Usuarios o de la veracidad de los Datos Personales por ellos ingresados. Cada Usuario conoce
      y
      acepta
      ser el exclusivo responsable por los artículos que publica para su venta y por las ofertas y/o compras que
      realiza.
    </p>

    <p>
      Debido a que Triidy no tiene ninguna participación durante todo el tiempo en que el artículo se publica para la
      venta, ni en la posterior negociación y perfeccionamiento del contrato definitivo entre las partes, no será
      responsable por el efectivo cumplimiento
      de las obligaciones asumidas por los Usuarios en el perfeccionamiento de la operación. El Usuario conoce y acepta
      que al realizar operaciones con otros Usuarios o terceros lo hace bajo su propio riesgo. En ningún caso Triidy
      Soft
      será responsable
      por lucro cesante, o por cualquier otro daño y/o perjuicio que haya podido sufrir el Usuario, debido a las
      operaciones realizadas o no realizadas por artículos publicados a través de Triidy Soft
    </p>

    <p>
      La transferencia <b>no se anula, ni Triidy la puede devolver, se pide la devolución del dinero directamente al
        beneficiario.</b> Triidy no puede quitarle el dinero de su cuenta al beneficiario, tiene que ser él quien lo
      devuelva voluntariamente. Si se trata de un error, deberá hacerlo, porque de lo contrario podría estar cometiendo
      un
      delito de apropiación
      indebida. Si el problema no se resuelve de manera satisfactoria, se podría solicitar la devolución vía judicial.
    </p>

    <p>
      <b>Triidy Soft</b>. recomienda actuar con prudencia y sentido común al momento de realizar operaciones con otros
      Usuarios. El Usuario debe tener presentes, además, los riesgos de contratar con menores o con personas que se
      valgan
      de una identidad
      falsa. Triidy Soft será responsable por la realización de ofertas y/o operaciones con otros Usuarios basadas en la
      confianza depositada en el sistema o los Servicios brindados por Triidy soft.
    </p>

    <p>
      En caso que uno o más Usuarios o algún tercero inicien cualquier tipo de reclamo o acciones legales contra otro u
      otros Usuarios, todos y cada uno de los Usuarios involucrados en dichos reclamos o acciones eximen de toda
      responsabilidad a Triidy Soft
      y a sus directores, gerentes, empleados, agentes, operarios, representantes y apoderados. Los Usuarios tienen un
      plazo de 60 días desde la compra para iniciar un reclamo contra otro u otros Usuarios. Una vez vencido este plazo,
      no podrán iniciar
      un reclamo desde el sitio de Triidy Soft.</p>

    <p><b> Alcance de los servicios de Triidy Soft</b></p>

    <p>
      Este acuerdo no crea ningún contrato de sociedad, de mandato, de franquicia, o relación laboral entre Triidy Soft
      y
      el Usuario. El Usuario reconoce y acepta que Triidy Soft no es parte en ninguna operación, ni tiene control alguno
      sobre la calidad, seguridad
      o legalidad de los artículos anunciados, la veracidad o exactitud de los anuncios, la capacidad de los Usuarios
      para
      vender o comprar artículos. Triidy Soft no puede asegurar que un Usuario completará una operación ni podrá
      verificar
      la identidad
      o Datos Personales ingresados por los Usuarios. Triidy Soft no garantiza la veracidad de la publicidad de terceros
      que aparezca en el sitio y no será responsable por la correspondencia o contratos que el Usuario celebre con
      dichos
      terceros
      o con otros Usuarios.
    </p>

    <p><b>Sanciones. Suspensión de operaciones</b></p>

    <p>
      Sin perjuicio de otras medidas, Triidy Soft podrá advertir, suspender en forma temporal o inhabilitar
      definitivamente la Cuenta de un Usuario o una publicación, aplicar una sanción que impacte negativamente en la
      reputación de un Usuario, iniciar las
      acciones que estime pertinentes y/o suspender la prestación de sus Servicios si (a) se quebrantara alguna ley, o
      cualquiera de las estipulaciones de los Términos y Condiciones Generales y demás políticas de Triidy soft (b) si
      incumpliera sus
      compromisos como Usuario; (c) si se incurriera a criterio de Triidy soft en conductas o actos dolosos o
      fraudulentos; (d) no pudiera verificarse la identidad del Usuario o cualquier información proporcionada por el
      mismo
      fuere errónea; (e)
      Triidy Soft entendiera que las publicaciones u otras acciones pueden ser causa de responsabilidad para el Usuario
      que las publicó, para Triidy soft o para los Usuarios. En el caso de la suspensión o inhabilitación de un Usuario,
      todos los
      artículos que tuviera publicados serán removidos del sistema. También se removerán del sistema las ofertas de
      compra
      de bienes ofrecidos en subasta.</p>

    <p><b>Fallas en el sistema</b></p>

    <p>
      <b>Triidy Soft</b> no se responsabiliza por cualquier daño, perjuicio o pérdida al Usuario causados por fallas en
      el
      sistema, en el servidor o en Internet. <b>Triidy Soft</b> tampoco será responsable por cualquier virus que pudiera
      infectar
      el equipo del Usuario como consecuencia del acceso, uso o examen de su sitio web o a raíz de cualquier
      transferencia
      de datos, archivos, imágenes, textos, o audio contenidos en el mismo. Los Usuarios NO podrán imputarle
      responsabilidad alguna
      ni exigir pago por lucro cesante, en virtud de perjuicios resultantes de dificultades técnicas o fallas en los
      sistemas o en Internet. <b>Triidy Soft</b> no garantiza el acceso y uso continuado o ininterrumpido de su sitio.
      El
      sistema puede
      eventualmente no estar disponible debido a dificultades técnicas o fallas de Internet, o por cualquier otra
      circunstancia ajena a <b>Triidy Soft</b> en tales casos se procurará restablecerlo con la mayor celeridad posible
      sin que por ello
      pueda imputársele algún tipo de responsabilidad. <b>Triidy Soft</b> no será responsable por ningún error u omisión
      contenidos en su sitio web.
    </p>

    <p><b>Tarifas. Facturación</b></p>

    <p>La inscripción en Triidy Soft es gratuita.</p>

    <p>El usuario solo deberá pagar a Triidy un costo por la entrega de cada producto cuando la operación se concrete y
      este pago va anexo ya al costo del envío que se genera en la plataforma</p>

    <p>
      En todos los casos, los cargos varían conforme al tipo de envío, ciudad de entrega, tamaño, valor a recaudar entre
      otros.
    </p>

    <p>El Usuario acepta pagar a <b>Triidy Soft</b> los cargos estipulados por transaccionar en la plataforma, los pagos
      se harán al monedero virtual o cuenta bancaria del cliente registrado.</p>

    <p><b>Triidy Soft</b> se reserva el derecho de modificar, cambiar, agregar, o eliminar las tarifas vigentes, en
      cualquier momento, lo cual será notificado a los Usuarios, en la forma establecida en la Cláusula 3. Sin embargo,
      <b>Triidy
        Soft</b> podrá modificar temporalmente la Política de Tarifas y las tarifas por sus servicios por razón de
      promociones, siendo efectivas estas modificaciones cuando se haga pública la promoción o se realice el anuncio.
    </p>

    <p><b>Triidy Soft</b> se reserva el derecho de tomar las medidas judiciales y extrajudiciales que estime pertinentes
      para obtener el pago del monto debido.</p>

    <p>
      En caso de haberse facturado cargos que no hubiesen correspondido, el Usuario deberá comunicarse con nuestro
      equipo
      de Atención al Cliente para resolver dicha cuestión. Cualquier duda consulte nuestras políticas de facturación.
    </p>

    <p>
      A su exclusiva discreción, <b>Triidy Soft </b>podrá expedir en forma electrónica las facturas correspondientes a
      las
      comisiones, cargos y demás conceptos originados en el uso de los Servicios por parte de los Usuarios, según
      Resolución 14.465
      de 2007 expedida por la DIAN.<b> La aceptación de los Términos y Condiciones Generales por el Usuario
        conlleva,
        entre otras cuestiones, el consentimiento expreso del Usuario a recibir las mencionadas facturas en forma
        electrónica.</b>
    </p>


    <p><b>Propiedad intelectual - Licencias - Enlaces</b></p>


    <p>
      Triidy Soft y/o sus sociedades controlantes, controladas, filiales o subsidiarias se reservan todos los derechos,
      incluyendo los derechos de propiedad intelectual e industrial, asociados con los servicios de Triidy Soft sus
      sitios
      web, los contenidos
      de sus pantallas, programas, bases de datos, redes, códigos, desarrollo, software, arquitectura, hardware,
      contenidos, información, tecnología, fases de integración, funcionalidades, dominios, archivos que permiten al
      Usuario acceder y crear
      su Cuenta, herramientas de venta, marcas, patentes, derechos de autor, diseños y modelos industriales, nombres
      comerciales, entre otros, y declara que están protegidos por leyes nacionales e internacionales vigentes.
    </p>


    <p>
      En ningún caso se entenderá que el Usuario tendrá algún tipo de derecho sobre los mismos excepto para utilizar el
      servicio de Triidy Soft conforme a lo previsto en estos Términos y Condiciones Generales. El uso indebido o
      contrario a la normativa vigente
      de los derechos de propiedad intelectual e industrial de Triidy Soft, así como su reproducción total o parcial,
      queda prohibido, salvo autorización expresa y por escrito de Triidy Soft</p>


    <p>
      Los Usuarios tampoco podrán comunicar que los productos o servicios que ofrecen son patrocinados, promovidos,
      producidos, ofrecidos y/o vendidos por Triidy soft deberán abstenerse de realizar cualquier acto que pudiera
      causar
      un daño, pérdida de reputación,
      o disminución del valor de los derechos de propiedad intelectual e industrial de Triidy Soft
    </p>

    <p>
      El sitio puede contener enlaces a sitios web de terceros. En virtud que Triidy Soft no tiene control sobre tales
      sitios, no será responsable por los contenidos, materiales, acciones y/o servicios prestados por los mismos, ni
      por
      daños o pérdidas ocasionadas
      por la utilización de éstos, causados directa o indirectamente. La presencia de enlaces a otros sitios web no
      implica una sociedad, relación, aprobación, respaldo de Triidy Soft con dichos sitios y sus contenidos.
    </p>

    <p><b>Indemnidad </b></p>

    <p>
      El Usuario mantendrá indemne a Triidy Soft, así como a sus filiales, empresas controladas y/o controlantes,
      funcionarios, directivos, sucesores, administradores, representantes y empleados, por cualquier reclamo iniciado
      por
      otros Usuarios, terceros o
      por cualquier Organismo, relacionado con sus actividades en el Sitio, el cumplimiento y/o el incumplimiento de los
      Términos y Condiciones Generales o demás Políticas, así como respecto de cualquier violación de leyes o derechos
      de
      terceros.
    </p>

    <p>
      A tal fin, el Usuario faculta a Triidy Soft a: i) intervenir y representarlo en dichos reclamos, pudiendo celebrar
      los acuerdos transaccionales que considere oportunos y que tiendan a evitar mayores costos y/o evitar eventuales
      contingencias sin limitación,
      en su nombre y representación; ii) retener y debitar de su Cuenta de Monedero y/o de la(s) cuenta(s) bancaria(s)
      registrada(s) en el monedero virtual los fondos existentes y/o futuros para recuperar cualquier gasto incurrido en
      relación a
      los supuestos del párrafo anterior, los cuales podrán incluir, entre otros, los honorarios de los letrados
      intervinientes y las costas judiciales en una cantidad razonable, y/o iii) generar débitos específicos en su
      facturación.
    </p>


    <p><b>Jurisdicción y Ley Aplicable</b></p>

    <p>Este acuerdo estará regido en todos sus puntos por las leyes vigentes en la República de Colombia.</p>

    <p>
      Cualquier controversia derivada del presente acuerdo, su existencia, validez, interpretación, alcance o
      cumplimiento, será sometida a las leyes aplicables y a los Tribunales competentes de la Ciudad de Medellín y los
      procedimientos se llevarán a cabo
      en idioma castellano.
    </p>

    <p> <b>Modificaciones del Acuerdo</b></p>

    <p>
      Triidy soft podrá modificar los Términos y Condiciones Generales en cualquier momento haciendo públicos en el
      Sitio
      los términos modificados. Todos los términos modificados entrarán en vigor a los 10 (diez) días de su publicación.
      Dichas modificaciones
      serán comunicadas por Triidy soft a los usuarios que en la Configuración de su Cuenta de Triidy soft hayan
      indicado
      que desean recibir notificaciones de los cambios en estos Términos y Condiciones. Todo usuario que no esté de
      acuerdo con las
      modificaciones efectuadas por Triidy soft podrá solicitar la baja de la cuenta.
    </p>

    <p><b>Domicilio</b></p>

    <p>
      Se fija como domicilio de <b>Triidy Soft Sas.</b>, con nit 901277226-5 la Carrera 77b · 48c – 64 de la ciudad de
      Medellín Antioquia Colombia. Teléfono (4) 5065844
    </p>
  </div>
</div>